<h4 class="m-0">
    Tyalls Configuration
</h4>

<div class="bg-white mt-3">
	<app-current-pricing-tier displayMode="both"></app-current-pricing-tier>
</div>


<div *ngIf="permsLoaded && !hasAnyAccess" class="p-3 text-center opacity-80">
	You don’t have access to this section.
</div>
<p-tabView
	*ngIf="hasAnyAccess"
	[(activeIndex)]="activeIndex"
	class="p-3"
	(onChange)="onTabChange($event.index)">
		<p-tabPanel *ngIf="canUsers" header="Users" headerStyleClass="p-1">
			<ng-template pTemplate="content">
					<div class="max-w-xl">
						<div class="font-semibold mb-2">Manage who can access your account and what they can see.</div>
						<ul class="list-disc pl-5 mb-2 text-sm">
							<li class="pb-3">Add or Remove Users, assign Groups, and set Roles — all from one place.</li>
							<li class="pb-3">Need help understanding Groups, Roles and general access info? Head to the
								<a href="{{this.supportHubLink}}" target="_blank" class="underline cursor-pointer">Support Hub</a> for more info.</li>
						</ul>
					</div>
					<app-user-table
						[currentProperty]="currentSelectedProperty"
						(addUserDialogOpen)="onAddUserOpen()">
					</app-user-table>

					<app-add-user-dialog
						[isVisible]="isAddUserVisible"
						[currentProperty]="currentSelectedProperty"
						(addUserDialogClose)="onDialogClose()">
					</app-add-user-dialog>
			</ng-template>
		</p-tabPanel>
		<p-tabPanel *ngIf="canGroups" header="Groups" headerStyleClass="p-1">
			<ng-template pTemplate="content">
				<div class="max-w-xl">
					<div class="font-semibold mb-2">Adding Groups:</div>
					<ul class="list-disc pl-5 mb-2 text-sm">
						<li class="pb-3">Select from hundreds of pre-defined Groups, from the dropdown list - If you cannot find the right Group, please contact
							<a href="mailto:{{this.tyallsSupportEmail}}">Tyalls Support</a> to have your custom Group created.</li>
						<li class="pb-3">Once you have chosen each Group, select ‘Activate’ to enable that Group.</li>
						<li class="pb-3">Maxed out your Group limit? You can Deactivate a Group, which will enable you to select a New Group from the dropdown list.</li>
						<li class="pb-3">Head to the <a href="{{this.supportHubLink}}" target="_blank" class="underline cursor-pointer">Support Hub</a> for more information.</li>
					</ul>
				</div>

				<app-groups-table
					(addGroupsDialogOpen)="onAddGroupOpen()">
				</app-groups-table>

				<app-add-group-dialog
					[isVisible]="isAddGroupVisible"
					(addGroupsDialogClose)="onGroupDialogClose()">
				</app-add-group-dialog>
			</ng-template>
		</p-tabPanel>
		<p-tabPanel *ngIf="canTasks" header="Task Management" headerStyleClass="p-1">
			<ng-template pTemplate="content">
				<div class="max-w-xl">
					<div class="font-semibold mb-2">Create and Edit Tasks (unlimited access):</div>
					<ul class="list-disc pl-5 mb-2 text-sm">
						<li class="pb-3">Creating a new Task is simple. Select ‘Create Task’, update relevant fields. If available, you can enable AI on the Task.</li>
						<li class="pb-3">To Edit any information within a Task, select ‘Edit’ and update the required fields. Note: If you would like to cancel AI, please contact
							<a href="mailto:{{this.tyallsSupportEmail}}">Tyalls Support</a></li>
						<li class="pb-3">Head to the <a href="{{this.supportHubLink}}" target="_blank" class="underline cursor-pointer">Support Hub</a> for more information.</li>
					</ul>
				</div>
				<app-task-management></app-task-management>
			</ng-template>
		</p-tabPanel>
	</p-tabView>



